import React from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { DATE_FORMAT } from "../../Config/appConfig";
import "react-datepicker/dist/react-datepicker.css";
import "../../style/customDatePicker.css";
const calendarIcon = require("../../resource/img/calendar.svg");

const CustomDatePicker = (props: ReactDatePickerProps) => {
  const years = React.useMemo(() => {
    const CURRENT = new Date().getFullYear();
    const MAX = CURRENT + 100;
    const MIN = CURRENT - 100;
    let years = [];

    for (let i = MAX; i >= MIN; i--) {
      years.push(i);
    }
    return years;
  }, []);
  const months = React.useMemo(
    () => [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    []
  );
  return (
    <div className="customDatePickerContainer">
      <img src={calendarIcon} />
      <DatePicker
        dateFormat="dd/M/yyyy HH:mm"
        showPopperArrow={false}
        showYearDropdown
        showMonthDropdown
        // showTimeInput
        showTimeSelect
        timeIntervals={1}
        className="customDatePicker cmText"
        {...props}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="customHeader">
            <button
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
              className="customNav prev"
            >
              {"‹"}
            </button>

            <select
              value={months[date.getMonth()]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <select
              value={date.getFullYear()}
              onChange={({ target: { value } }) => changeYear(+value)}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <button
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
              className="customNav next"
            >
              {"›"}
            </button>
          </div>
        )}
      />
    </div>
  );
};
export default CustomDatePicker;



// WEBPACK FOOTER //
// ./src/Components/Custom/CustomDatePicker.tsx